//import { InforModal } from "../model/datatype";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UniformImage from "../components/font-end/UniformSurvey/UniformImage";
//import { GetShirtTypeImages } from "../services/ApiUniformSurvey";

export const ConfirmYourInformationModal = (props: any) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  //console.log('props.surveys=',props.surveys);

  useEffect(() => {
    // GetShirtTypeImages(props.surveys.shirtType).then((response:any) => {
    //     setImagByType(response);
    // })
  }, []);

  //console.log("props ConfirmYouinformation.=", props);

  const arrGender: any = {
    Female: "หญิง",
    Male: "ผู้ชาย",
  };
  return (
    <Modal
      show={props.showModal}
      onHide={props.handleContinue}
      backdrop="static"
      keyboard={true}
      className="custom-modal-uniform uniformModel"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-center w-100">
          {t("uniform_survey.conform_your_uniform.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="uniform-survey-info ">
          <Container>
            {props.surveys?.shirtQty !== null ? (
              <Row className="align-items-center mb-2">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <UniformImage
                    imagesName={props.uniformImage}
                    size="sm"
                    customSize=""
                  />
                  {/* <img
                    src={props.uniformImage}
                    alt="UniformSurvey"
                    width={50}
                    className="mt-2 rounded border item-shadow"
                  /> */}
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title font-wiegth-bold ">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.shirtDescriptionEn
                      : props.benefit?.shirtDescriptionTh}
                  </div>
                  <div className="list-size">
                    {/* {t('uniform_survey.choose_uniform.big_size')} */}
                    {/* {(props.surveys?.shirtSize !== "Decline")?"Size: "+props.surveys?.shirtSize+"("+props.surveys?.shirtGender+")":<><span className='text-danger'>{t('uniform_survey.choose_uniform.no_receive')}</span></>} */}
                    {props.surveys?.shirtSize === "Decline" ? (
                      <>
                        <span className="text-danger">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.shirtSize === "Bigger than normal size" ? (
                      <>
                        {t("uniform_survey.choose_uniform.big_size")}(
                        {localStorage.getItem("Language") === "en"
                          ? props.surveys?.shirtGender
                          : arrGender[props.surveys?.shirtGender]}
                        )
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.shirtSize !== "Bigger than normal size" &&
                    props.surveys?.shirtSize !== "Decline" ? (
                      <>
                        {t("uniform_survey.choose_uniform.size")}:{" "}
                        {props.surveys?.shirtSize} (
                        {localStorage.getItem("Language") === "en"
                          ? props.surveys?.shirtGender
                          : arrGender[props.surveys?.shirtGender]}
                        )
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {props.surveys?.shirtSize === "Bigger than normal size" ? (
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {props.surveys?.shirtSizeDescription}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number mt-4">
                    {props.surveys?.shirtSize !== "Decline"
                      ? props.surveys?.shirtQty
                      : 0}
                  </div>
                </Col>
              </Row>
            ) : (
              <></>
            )}

            {props.surveys?.pantQty !== null ? (
              <Row className="align-items-center mb-2">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/pants.png"
                    alt="UniformSurvey"
                    width={50}
                    className="mt-2 rounded border item-shadow"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title font-wiegth-bold">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.pantsDescriptionEn
                      : props.benefit?.pantsDescriptionTh}
                  </div>
                  <div className="list-size">
                    {/* {(props.surveys?.pantSize !== "Decline")?"Size: "+props.surveys?.pantSize+"("+props.surveys?.pantGender+")":<><span className='text-danger'>{t('uniform_survey.choose_uniform.no_receive')}</span></>} */}
                    {props.surveys?.pantSize === "Decline" ? (
                      <>
                        <span className="text-danger">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.pantSize === "Bigger than normal size" ? (
                      <>
                        {t("uniform_survey.choose_uniform.big_size")}(
                        {localStorage.getItem("Language") === "en"
                          ? props.surveys?.pantGender
                          : arrGender[props.surveys?.pantGender]}
                        )
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.pantSize !== "Bigger than normal size" &&
                    props.surveys?.pantSize !== "Decline" ? (
                      <>
                        {t("uniform_survey.choose_uniform.size")}:{" "}
                        {props.surveys?.pantSize}{" "}
                        {t("uniform_survey.choose_uniform.UnitBar")} (
                        {localStorage.getItem("Language") === "en"
                          ? props.surveys?.pantGender
                          : arrGender[props.surveys?.pantGender]}
                        )
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {props.surveys?.pantSize === "Bigger than normal size" ? (
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {props.surveys?.pantSizeDescription}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number mt-4">
                    {props.surveys?.pantSize !== "Decline"
                      ? props.surveys?.pantQty
                      : 0}
                  </div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.surveys?.dressQty !== null ? (
              <Row className="align-items-center mb-2">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/dress.png"
                    alt="UniformSurvey"
                    width={50}
                    className="mt-2 rounded border item-shadow"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title font-wiegth-bold">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.dressDescriptionEn
                      : props.benefit?.dressDescriptionTh}
                  </div>
                  <div className="list-size">
                    {/* {(props.surveys?.dressSize !== "Decline")?"Size: "+props.surveys?.dressSize:<><span className='text-danger'>{t('uniform_survey.choose_uniform.no_receive')}</span></>} */}
                    {props.surveys?.dressSize === "Decline" ? (
                      <>
                        <span className="text-danger">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.dressSize === "Bigger than normal size" ? (
                      <>{t("uniform_survey.choose_uniform.big_size")}</>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.dressSize !== "Bigger than normal size" &&
                    props.surveys?.dressSize !== "Decline" ? (
                      <>
                        {t("uniform_survey.choose_uniform.size")}:{" "}
                        {props.surveys?.dressSize}{" "}
                        {t("uniform_survey.choose_uniform.UnitSlipper")}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {props.surveys?.dressSize === "Bigger than normal size" ? (
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {props.surveys?.dressSizeDescription}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number mt-4">
                    {props.surveys?.dressSize !== "Decline"
                      ? props.surveys?.dressQty
                      : 0}
                  </div>
                </Col>
              </Row>
            ) : (
              <></>
            )}

            {props.surveys?.braQty !== null ? (
              <Row className="align-items-center mb-2">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/bras.png"
                    alt="UniformSurvey"
                    width={50}
                    className="mt-2 rounded border item-shadow"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title font-wiegth-bold">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.braDescriptionEn
                      : props.benefit?.braDescriptionTh}
                  </div>
                  <div className="list-size">
                    {/* {props.surveys?.braSize !== 'Decline' ? (
                      'Size: ' + props.surveys?.braSize
                    ) : (
                      <>
                        <span className="text-danger">
                          {t('uniform_survey.choose_uniform.no_receive')}
                        </span>
                      </>
                    )} */}
                    {props.surveys?.braSize === "Decline" ? (
                      <>
                        <span className="text-danger">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.braSize === "Bigger than normal size" ? (
                      <>{t("uniform_survey.choose_uniform.big_size")}</>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.braSize !== "Bigger than normal size" &&
                    props.surveys?.braSize !== "Decline" ? (
                      <>
                        {" "}
                        {t("uniform_survey.choose_uniform.size")}:{" "}
                        {props.surveys?.braSize} (
                        {t("uniform_survey.choose_uniform.UnitSlipper")}/{" "}
                        {t("uniform_survey.choose_uniform.UnitBar")})
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {props.surveys?.braSize === "Bigger than normal size" ? (
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {props.surveys?.braSizeDescription}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number mt-4">
                    {props.surveys?.braSize !== "Decline"
                      ? props.surveys?.braQty
                      : 0}
                  </div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.surveys?.slipperQty !== null ? (
              <Row className="align-items-center mb-2">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/slippers.png"
                    alt="UniformSurvey"
                    width={50}
                    className="mt-2 rounded border item-shadow"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title font-wiegth-bold">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.slipperDescriptionEn
                      : props.benefit?.slipperDescriptionTh}
                  </div>
                  <div className="list-size">
                    {props.surveys?.slipperSize === "Decline" ? (
                      <>
                        <span className="text-danger">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.slipperSize ===
                    "Bigger than normal size" ? (
                      <>{t("uniform_survey.choose_uniform.big_size")}</>
                    ) : (
                      <></>
                    )}
                    {props.surveys?.slipperSize !== "Bigger than normal size" &&
                    props.surveys?.slipperSize !== "Decline" ? (
                      <>
                        {t("uniform_survey.choose_uniform.size")}:{" "}
                        {props.surveys?.slipperSize}{" "}
                        {t("uniform_survey.choose_uniform.UnitSlipper")}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {props.surveys?.slipperSize ===
                    "Bigger than normal size" ? (
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {props.surveys?.slipperSizeDescription}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number mt-4">
                    {props.surveys?.slipperSize !== "Decline"
                      ? props.surveys?.slipperQty
                      : 0}
                  </div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.surveys?.tumblerQty !== null ? (
              <Row className="align-items-center mb-2">
                <Col xs={2} md={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/tumbler.png?a1"
                    alt="UniformSurvey"
                    width={50}
                    className="mt-2 rounded border item-shadow"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title font-wiegth-bold">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.tumblerDescriptionEn
                      : props.benefit?.tumblerDescriptionTh}
                  </div>
                  <div className="list-size">
                    {props.surveys?.tumblerType !== "Decline" ? (
                      t("uniform_survey.choose_uniform.receive")
                    ) : (
                      <>
                        <span className="text-danger">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </span>
                      </>
                    )}

                    {props.surveys?.tumblerType ===
                    "Bigger than normal size" ? (
                      <>{t("uniform_survey.choose_uniform.big_size")}</>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number mt-4">
                    {props.surveys?.tumblerType !== "Decline"
                      ? props.surveys?.tumblerQty
                      : 0}
                  </div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            <Row className="align-items-center mb-0 mt-2">
              <Col
                xs={12}
                md={12}
                lg={12}
                className="text-danger"
                style={{ fontSize: "14px" }}
              >
                {t("uniform_survey.choose_uniform.remark")}:{" "}
                {t("uniform_survey.choose_uniform.remarkConfrim")}
              </Col>
            </Row>
          </Container>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="text-center w-100">
          {/* ปุ่ม Cancel ใช้ค่าปกติ */}
          <Button className="btn-no mx-2" onClick={props.cancel}>
            {t("uniform_survey.conform_your_uniform.btn_cancel")}
          </Button>

          {/* ปุ่ม Confirm พร้อม spinner, layout สวย, ไม่เบี้ยว */}
          <Button
            className="btn-yes mx-2 d-inline-flex align-items-center justify-content-center gap-2"
            style={{ minWidth: "150px" }}
            variant="primary"
            disabled={props.isLoading}
            onClick={props.click_yes}
          >
            {props.isLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            {props.isLoading
              ? t("uniform_survey.conform_your_uniform.btn_confirming")
              : t("uniform_survey.conform_your_uniform.btn_confirm")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
